
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/utils/analyticsTracker';
import { useAuth } from '@/context/AuthContext';

export const usePageTracking = () => {
  const location = useLocation();
  const { user } = useAuth();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Don't track the same page twice in a row
    if (previousPath.current === currentPath) {
      return;
    }
    
    // Track page view with current user info if available
    trackPageView({
      pagePath: currentPath,
      userId: user?.id || null,
      userEmail: user?.email || null,
      extraData: {
        search: location.search,
        hash: location.hash,
        isAuthenticated: !!user
      }
    });
    
    // Log for debugging
    console.log(`Page tracked: ${currentPath}`);
    
    // Remember this path to avoid duplicate tracking
    previousPath.current = currentPath;
    
    // Log the navigation event with additional data
    console.log('Navigation occurred to:', currentPath, {
      timestamp: new Date().toISOString(),
      href: window.location.href,
      user: user ? user.email : 'anonymous'
    });
  }, [location.pathname, user]);
};
